var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buyer-supply" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            width: "640px",
            align: "center",
            title: "批量改「买手组与买手」",
            visible: _vm.visible,
            "before-close": _vm.closeBox
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商家id（一行一个，最多1000个）",
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              rows: 8,
                              type: "textarea",
                              placeholder: "一行一个id"
                            },
                            model: {
                              value: _vm.form.supply_ids,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "supply_ids", $$v)
                              },
                              expression: "form.supply_ids"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { style: { marginTop: "40px" }, attrs: { span: 14 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "选择买手组",
                            align: "left",
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", filterable: "" },
                              on: { change: _vm.getGroupMember },
                              model: {
                                value: _vm.form.pg_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "pg_id", $$v)
                                },
                                expression: "form.pg_id"
                              }
                            },
                            _vm._l(_vm.buyerGroups, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { value: item.value, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "选择买手",
                            align: "left",
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", filterable: "" },
                              model: {
                                value: _vm.form.supply_picker_group_member_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "supply_picker_group_member_id",
                                    $$v
                                  )
                                },
                                expression: "form.supply_picker_group_member_id"
                              }
                            },
                            _vm._l(_vm.buyers, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { value: item.value, label: item.label }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeBox } },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "success" },
                  on: { click: _vm.submitData }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a3568d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a3568d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/components/BuyerBindSupply.vue
// module id = null
// module chunks = 